import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { QuestionsComponent } from './questions/questions.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { IntroPageComponent } from './intro-page/intro-page.component';
import { SurveyClosedComponent } from './survey-closed/survey-closed.component';
import { QuestionsResolver } from './questions/questions.resolver';
import { IntroPageResolver } from './intro-page/intro-page.resolver';
import { ErrorPageComponent } from './error-page/error-page.component';

const routes: Routes = [
  { 
    path: 'launch/:launchId', 
    component: IntroPageComponent,
    resolve: { introPageData: IntroPageResolver }
  },
  { 
    path: 'launch/:launchId/:preview',
    component: IntroPageComponent,
    resolve: { introPageData: IntroPageResolver }
  },
  { 
    path: 'response/:responseId', 
    component: IntroPageComponent,
    resolve: { introPageData: IntroPageResolver }
  },
  { 
    path: 'response/:responseId/:preview', 
    component: IntroPageComponent,
    resolve: { introPageData: IntroPageResolver }
  },
  {
    path: 'questions/response/:responseId', 
    component: QuestionsComponent,
    resolve: { questionsData: QuestionsResolver }
  }, 
  {
    path: 'questions/response/:responseId/:preview', 
    component: QuestionsComponent,
    resolve: { questionsData: QuestionsResolver }
  }, 
  { path: 'thankyou/:responseId', component: ThankYouComponent},
  { path: 'surveyClosed/:launchId', component: SurveyClosedComponent},

  { path: 'error', component: ErrorPageComponent },

  // Wildcard route for a 404 page
  { path: '**', component: ErrorPageComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
